var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.timeWindowUpdatePermission)?_c('div',{attrs:{"id":"page-user-edit"}},[_c('vx-card',[(_vm.timeWindow !== null)?_c('time-window-edit-tab',{attrs:{"dataTimeWindow":_vm.timeWindow}}):_vm._e()],1)],1):_c('not-permission')
}
var staticRenderFns = []

export { render, staticRenderFns }